export const environment = {
  url: {
    api: `https://apim-uat.houseofhr.com/square-app-avanti/api/v2.0`,
  },
  production: true,
  ocpApimSubscriptionKey: '610ca884b45b4b6bb73bf275f2b31f72'
};

